type RuntimeNoiseLevel = 'verbose' | 'minimal';

const DEBUG_KEYS = ['sl_debug', 'sl_runtime_debug', 'sl_runtime_verbose'];

function safeHostname(): string {
  if (typeof window === 'undefined') return '';
  return String(window.location.hostname || '').toLowerCase();
}

export function isPreviewDomain(hostname = safeHostname()): boolean {
  if (!hostname) return false;
  return (
    hostname.endsWith('.vercel.app') ||
    hostname.startsWith('dev.') ||
    hostname.startsWith('beta.')
  );
}

function hasDebugOverride(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    if ((window as any).SNAP_DEBUG === true) return true;
    return DEBUG_KEYS.some((key) => localStorage.getItem(key) === '1');
  } catch {
    return false;
  }
}

export function isDiagnosticsDomain(hostname = safeHostname()): boolean {
  if (!hostname) return false;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.localhost')
  );
}

export function getRuntimeNoiseLevel(): RuntimeNoiseLevel {
  if (import.meta.env.DEV || isDiagnosticsDomain() || isPreviewDomain() || hasDebugOverride()) {
    return 'verbose';
  }
  return 'minimal';
}

export function isRuntimeVerbose(): boolean {
  return getRuntimeNoiseLevel() === 'verbose';
}
